import { useCallback } from "react";

import {
  createFileRoute,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";

import { Route as SignInRoute } from "@app/navigation/routes/_public/sign-in";
import { sessionsListQueryOptions } from "@entities/session/hooks/use-sessions-list";
import { SessionDetailsPageConnector } from "@pages/session-details";

export const Route = createFileRoute("/_private/sessions/$id")({
  component: RouteComponent,
  loader: async ({ context }) => {
    await context.queryClient.ensureInfiniteQueryData(
      sessionsListQueryOptions({}),
    );
  },
});

function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const router = useRouter();

  const handleSignOut = useCallback(async () => {
    await navigate({ to: SignInRoute.fullPath });
  }, [navigate]);

  return (
    <SessionDetailsPageConnector
      id={id}
      onGoBack={router.history.back}
      onSignOut={handleSignOut}
    />
  );
}
